import React from "react";
import { motion } from "framer-motion";
import { Target } from "lucide-react";

export default function TargetIndicator({ rate = 0, target = 90, studentsTotal = 0, studentVols = 0, subtitle, testId, groupNoun = "الطلبة", singularVol = "طالباً متطوعاً" }) {
  const pct = Math.min(100, rate);
  const reached = rate >= target;
  const color = reached ? "#10B981" : rate >= 60 ? "#D4AF37" : rate >= 30 ? "#F59E0B" : "#EF4444";
  const needed = Math.ceil((target / 100) * studentsTotal);
  const remaining = Math.max(0, needed - studentVols);
  return (
    <div data-testid={testId} className="glass rounded-2xl p-5 relative overflow-hidden">
      <div className="absolute -left-10 -top-10 w-32 h-32 rounded-full blur-2xl opacity-20" style={{ background: color }} />
      <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <Target className="text-sky-600" size={22} />
          <h3 className="font-head font-bold text-stone-800 text-lg">مؤشر التمكين المستهدف — مشاركة {target}% من {groupNoun}</h3>
        </div>
        <span className="text-3xl font-head font-bold" style={{ color }}>{rate}%</span>
      </div>
      {subtitle && <p className="text-xs text-stone-500 mb-3">{subtitle}</p>}
      <div className="relative h-5 rounded-full bg-stone-200/70 overflow-hidden">
        <motion.div
          initial={{ width: 0 }} animate={{ width: `${pct}%` }} transition={{ duration: 1, ease: "easeOut" }}
          className={`h-full rounded-full ${reached ? "animate-pulse" : ""}`} style={{ background: color }}
        />
        <div className="absolute inset-y-0 border-l-2 border-dashed border-emerald-600/70" style={{ left: `${100 - target}%` }} />
      </div>
      <div className="flex justify-between text-[11px] text-stone-500 mt-1">
        <span>0%</span>
        <span className="font-bold text-emerald-700">المستهدف {target}%</span>
        <span>100%</span>
      </div>
      {studentsTotal > 0 && (
        reached
          ? <p className="mt-3 text-center text-emerald-700 font-bold text-sm">🎉 مبروك! تم تحقيق المستهدف الاستراتيجي</p>
          : <p className="mt-3 text-center text-stone-700 text-sm">يتبقّى <b style={{ color }}>{remaining}</b> {singularVol} لبلوغ المستهدف (المطلوب {needed} من {studentsTotal})</p>
      )}
    </div>
  );
}
